import { useState, useEffect, useCallback } from "react";

/**
 * Custom hook to read and subscribe to global active session from Header (Firm, Branch, Month, Year).
 * Updates automatically across components whenever Header changes Firm, Branch, Month, or Year!
 */
export const useSession = () => {
  const getSession = useCallback(() => {
    let firm = null;
    let branch = null;
    let month = "";
    let year = "";
    try {
      firm = JSON.parse(localStorage.getItem("selectedFirm") || "null");
    } catch {
      firm = null;
    }
    try {
      branch = JSON.parse(localStorage.getItem("selectedBranch") || "null");
    } catch {
      branch = null;
    }
    month = localStorage.getItem("selectedPayrollMonth") || "";
    year = localStorage.getItem("selectedPayrollYear") || "";

    return {
      firm,
      firmId: firm?.Id || 0,
      firmName: firm?.Name || "",
      branch,
      branchId: branch?.Id || 0,
      branchName: branch?.Name || "",
      month,
      year,
    };
  }, []);

  const [session, setSession] = useState(getSession);

  useEffect(() => {
    const handleUpdate = () => {
      setSession(getSession());
    };

    window.addEventListener("storage", handleUpdate);
    window.addEventListener("sessionChange", handleUpdate);
    return () => {
      window.removeEventListener("storage", handleUpdate);
      window.removeEventListener("sessionChange", handleUpdate);
    };
  }, [getSession]);

  return session;
};

export default useSession;
